import { useWelcomeFlowStore } from "@/stores/welcomeFlow/welcomeFlow.store";
import { waitForProjectDashboardReady } from "@/layouts/composables/useProjectDashboardReadySignal";

import { createDeckWelcomeFlow } from "./deckWelcomeFlow";
import { projectDeck } from "./decks";

const projectWelcomeFlow = createDeckWelcomeFlow({
  deck: projectDeck,
  waitForReady: waitForProjectDashboardReady,
  // Read (and cleared) only once the tour is confirmed to open — a later visit must not also claim
  // to be "right after creation".
  resolveOpenTourOptions: () => ({ afterCreation: useWelcomeFlowStore().consumeNextProjectTourAfterCreation() }),
});

/** For the start-dialog redirect: would opening the dashboard right now show the project tour? */
export function isProjectTourPending(): Promise<boolean> {
  return projectWelcomeFlow.isPending();
}

export async function checkAndShowProjectTour(projectId: string): Promise<void> {
  await projectWelcomeFlow.checkAndShow({ projectId });
}
